var W = require('./dist/bi-logger/wix-bi');
module.exports = W;